import { User } from 'src/constants';
import {
  AddressCustomFieldValues,
  Client,
  Company,
  CustomFieldOption,
} from 'src/store/clients/types';

export interface VisibilityDropdownProps {
  clientCompanyId: string;
  assignees: User[];
  lead: User;
}

export interface DetailSectionProps {
  currentClient?: Client;
  currentCompany?: Company;
}

export interface CustomPropertiesListProps {
  setPropertiesMenuAnchor: React.Dispatch<
    React.SetStateAction<HTMLElement | null>
  >;
  openUpdateCustomFieldMenu: (
    ev: React.MouseEvent<HTMLElement, MouseEvent>,
    updatingField: CustomFieldOption,
  ) => void;
  anchoredCustomFieldId: string | null;
  clientUser?: Client;
  company?: Company;
  customFields: CustomFieldOption[] | null;
  onSaveProperty: (
    customField: CustomFieldOption | null,
    deletedOptionKey?: string,
  ) => Promise<void>;
}

export interface ClientDetailsQueryParams {
  clientUserId: string;
  channelId: string;
  activeTabKey?: string;
}

export type CustomFieldValue =
  | string
  | string[]
  | boolean
  | AddressCustomFieldValues;

export const isAddressCustomFieldValues = (
  customFieldValue: CustomFieldValue,
): customFieldValue is AddressCustomFieldValues =>
  (customFieldValue as AddressCustomFieldValues).fullAddress !== undefined;

export interface CustomFieldValueData {
  fieldId: string;
  value?: CustomFieldValue;
  updatingClient?: Client;
  updatingCompany?: Company;
}
